import { render } from "./AccoutPage.vue?vue&type=template&id=6841bd2a&scoped=true"
import script from "./AccoutPage.vue?vue&type=script&lang=js"
export * from "./AccoutPage.vue?vue&type=script&lang=js"

import "./AccoutPage.vue?vue&type=style&index=0&id=6841bd2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6841bd2a"]])

export default __exports__